import {Component, OnInit} from '@angular/core';
import {Customer} from '../../../dto/customer';
import {calculateAge, toDateString, toDateTimeString} from "../../../providers/app-date-adapter";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CustomersService} from '../../services/customers.service';
import {Location} from '@angular/common';
import {CardsService} from '../../services/cards.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RoleService} from '../../../services/role.service';
import {OrdersService} from '../../services/orders.service';
import {IdentStatus} from '../../../dto/ident-status';
import {WebIdTransaction} from '../../../dto/web-id-transaction';
import {Order} from '../../../dto/order';
import {Country} from '../../../dto/country';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {OrdersCancellationsInternService} from '../../services/orders-cancellations-intern.service';
import {InvoiceLineItem} from '../../../dto/invoice-line-item';
import {CardReorderReason} from '../../../dto/card-reorder-reason';
import {Card} from '../../../dto/card';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {ProductService} from '../../services/product.service';
import {PrevNextIdModel} from '../../../models/prev-next-id-model';
import {ToastService} from 'angular-toastify';
import {AnnualFeeDeduction, Invoice} from "../../../dto/invoice";
import {InvoicesService} from "../../services/invoices.service";
import {AnnualFeeDeductionService} from "../../services/annual-fee-deduction.service";


@Component({
  selector: 'app-orders-cancellations-intern-detail',
  templateUrl: './orders-cancellations-intern-detail.component.html',
  styleUrls: ['./orders-cancellations-intern-detail.component.css']
})




export class OrdersCancellationsInternDetailComponent implements OnInit {

  prevId: number|null;
  nextId: number|null;

  orderId: number;
  public orderCancellationStatusSelect = new FormControl();
  public selectedFee = new FormControl();

  //prevNext: PrevNextModel;
  order: Order = null;
  customer: Customer = null;

  addedFeeForm: FormGroup;
  feeSum = 0;

  feeEditEnabled = true;

  showAnnualFee = false;
  showIssuingFee = false;
  isLoadingCards = false;
  prevNextIds: PrevNextIdModel;
  customerId: number|null;



  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private orderService: OrdersService,
    private ordersCancellationsInternService: OrdersCancellationsInternService,
    private cardsService: CardsService,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private productService: ProductService,
    private invoicesService: InvoicesService,
    private annualFeeDeductionService: AnnualFeeDeductionService,
    private _toastService: ToastService,

  ) { }

  fields = [
    { header: 'Name', cell: (row: Customer) => `${row.firstName} ${row.lastName}`, link: row => '../../customers-overview/' + row.id, icon: (row: Customer) => 'visibility', },

    { header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}` },
    { header: 'Country', cell: (row: Customer) => `${row.countryName || ''}` },

    { header: 'Email', cell: (row: Customer) => `${row.email || ''}` },
    { header: 'Mobile', cell: (row: Customer) => `+${row.phone || ''}` },
    { header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob) || ''}` },
    {header: 'Age', cell: (row: Customer) => {
        if ( !row.dob ) {
          return '-';
        }
        return calculateAge(row.dob) + ' years';
      }},

    { header: 'IP Address', cell: (row: Customer) => `${row.ipAddress || ''}` },


  ] as ContentRowField<Customer>[];

  orderFields =[
    { header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}` },
    { header: 'Status', cell: (row: Order) => `${row.statusName}` },
    { header: 'Ident ID', cell: (row: Order) => `${(row.webIdTransaction || ({} as WebIdTransaction)).id || 'No Ident'}` },
    { header: 'Ident status', cell: (row: Order) => `${IdentStatus[(row.webIdTransaction || ({} as WebIdTransaction)).status] || 'No Ident'}` },
  ];


  calcFeeSum(){
    if( this.feeArray == null ) {
return;
}

    this.feeSum = 0;
    this.feeArray.controls.forEach(fee => {
      if(!fee.value.archived) {
        let f = this.feeSum + (fee.value.amountValue * fee.value.multiplikatorValue);

        f = Math.round((f + Number.EPSILON) * 100) / 100;

        this.feeSum = f;
      }
    });
  }


  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.orderId = idParam;
      //this.prevNext = null;

      this.addedFeeForm = this.formBuilder.group({
        fees: this.formBuilder.array([])
      });

      this.refreshOrder();
      //this.getPrevNext(idParam);
      this.getPrevNextIds(idParam);




    });

  }

  currentUserCanChangeSomething(){

    if( this.roleService.hasRoles('admin') || this.roleService.hasRoles('agent') || this.roleService.hasRoles('manager') || this.roleService.hasRoles('compliance') ) {
      return true;
    }

    if( this.roleService.hasRoles('partner')) {
      return false;
    }

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  currentUserIsAgent() {
    return this.roleService.hasRoles('agent');
  }

  get feeArray() {
    const control = <FormArray>(this.addedFeeForm.get('fees'));
    return control;
  }

  addFee(item) {
    (<FormArray>(this.addedFeeForm.get('fees'))).push(this.formBuilder.group(item));
  }

  deleteFee(index, fee){

    if(fee.value.id == null) {
      (<FormArray>(this.addedFeeForm.get('fees'))).removeAt(index);
    } else{
      fee.controls['archived'].patchValue(true);
    }

  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }
  currentUserIsAdminOrManager(): boolean {
 return this.roleService.hasRoles([ 'admin', 'manager', 'compliance' ] );
}
  currentUserIsAdminOrManagerOrAgent(): boolean {
 return this.roleService.hasRoles([ 'admin', 'manager', 'agent', 'compliance' ] );
}



  showMessage(msg: string) {
    this._toastService.success(msg);
  }

  showInfo(msg: string) {
    this._toastService.info(msg);
  }

  returnBack() {
    this.location.back();
  }


  disableChanges = true;
  isLoading = false;
  cardReorderReason = CardReorderReason;
  cards: Card[] = [];
  cardFields = [
    {header: 'Card Token', icon: (row: Card) => 'visibility', link: (row: Card) => this.currentUserIsPartner() ? null : '../../cards/' + row.id, cell: (row: Card) => `${row.token}`},
    {header: 'Creation date', cell: (row: Card) => `${toDateTimeString(row.creationDate) || ''}`},
    {header: 'Shipping date', cell: (row: Card) => `${toDateString(row.shippedDate) || ''}`},
    {header: 'Activation date', cell: (row: Card) => `${toDateTimeString(row.activationDate) || ''}`},
    {header: 'Order date', cell: (row: Card) => `${toDateString(row.orderDate) || ''}`},
    {header: 'Next Annual Fee', cell: (row: Card) => `${toDateString(row.nextAnnualFeeDateDisplayed || row.nextAnnualFeeDate) || ''}` } as ContentRowField<Card>,

    {header: 'PAN', cell: (row: Card) => `${row.maskedPAN || '(unknown)'}`},
    {header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`},

    {header: 'Invoice', link: (row: Card) => '../../invoices/' + row.order.invoiceId, cell: (row: Card) => `${row.order.invoiceNumber || ''}`},

    // { header: "Payment Reminders" , cell: (row: Card) => "<a payment-reminders" + row.token + " " + `${ row.order.paymentEmailReminders.length || 0 }` },
    // DO NOT DELETE
    // { header: "Rec ID", cell: (row: Card) => `${row.recId || ""}` },
    // { header: "Status", cell: (row: Card) => `${row.statusName || ""}` },
    // { header: "Comment", cell: (row: Card) => `${row.comment || ""}` },
    // { header: "Pull date", cell: ( row: Card ) => `${ toDateTimeString( row.pullDate ) || "" }` },
  ] as ContentRowField<Card>[];


  currentUserIsIssuerExternal(): boolean {
    return this.roleService.hasRoles(['issuer_external']);
  }

  refreshOrder() {
    this.addedFeeForm = this.formBuilder.group({
      fees: this.formBuilder.array([])
    });

    this.disableChanges = true;

    this.isLoadingCards = true;
    this.isLoading = true;
    this.ordersCancellationsInternService.get( this.orderId ).subscribe( data => {
      this.order = data;
      this.customerId = this.order.customerId;

      if( this.order.product.issuingFee > 0 ){
        this.showIssuingFee = true;
      }
      if( this.order.product.annualFee > 0 || this.order.product.annualFeeFromSecondYear > 0 ){
        this.showAnnualFee = true;
      }

      // load invoices and annual fee deductions
      if ( !this.currentUserIsIssuerExternal()) {
        this.invoicesService.getByCustomerId(this.customerId, true).subscribe(data => {
          this.invoices = data;
        });
      }

      if ( !this.currentUserIsIssuerExternal()) {
        this.isLoadingAnnualFeeDeductions = true;
        this.annualFeeDeductionService.getByCustomerId(this.customerId).subscribe(data => {
          this.annualFeeDeductions = data;
          this.isLoadingAnnualFeeDeductions = false;
        });
      }

      this.productService.getAll().subscribe(pdata => {
        const products = pdata.data;
        this.customersService.get( data.customerId ).subscribe( data => {
          this.customer = data;
          this.isLoading = false;
          const cards = [];
          this.customer.cards.forEach(card => {
            card.product = products.filter(p => p.id == card.productId)[0];
            cards.push(card);
          });

          this.cards = cards;
          this.isLoadingCards = false;
        });
      });



      this.orderCancellationStatusSelect.patchValue(data.cancellationStatus);
      if( data.cancellationStatus != 2 ){
        this.disableChanges = false;
      }

      // Invoice
      if( data.cancellationInvoice != null && !data.cancellationInvoice.archived){

        if( !data.cancellationInvoice.isFinished ) {
this.feeEditEnabled = true;
} else {
this.feeEditEnabled = false;
}

        if (data.cancellationInvoice.invoiceLineItems != null){

          data.cancellationInvoice.invoiceLineItems.forEach(item => {
            if(!item.archived) {
this.initAddFeeToList(item.feeType, item.singleAmount, item.numberOfItems, item.name, item.id, item.vatRate);
}
          });

          if( data.cancellationInvoice.isFinished ) {
this.addedFeeForm.disable();
}

          this.addedFeeForm.markAsPristine();


          this.calcFeeSum();

        }
      }

      this.addedFeeForm.valueChanges.subscribe(x => {
        this.calcFeeSum();
        this.addedFeeForm.markAsDirty();
      });


    });

  }

  save(){
    this.order.cancellationStatus = this.orderCancellationStatusSelect.value;

    this.ordersCancellationsInternService.updateCancellationStatus( this.order ).subscribe( data => {
      this.showMessage('Cancellationstatus saved.');
      this.refreshOrder();
    });
  }

  getFeesForSave(){
    const invoiceLineItems = [];

    this.feeArray.controls.forEach(fee => {

      const item = new InvoiceLineItem();
      item.feeType = fee.value.feeType;
      // do this in backend
      // item.amount = Number(fee.value.amountValue) * Number(fee.value.multiplikatorValue);
      item.numberOfItems = fee.value.multiplikatorValue;
      item.name = fee.value.name;
      item.singleAmount = fee.value.amountValue;
      item.id = fee.value.id;
      item.archived = fee.value.archived;
      item.vatRate = fee.value.vatRate;

      if( fee.value.showCustomName ){
        item.name = fee.value.customNameValue;
      }

      if( fee.value.showYesNo ) {
item.amount = 0;
}

      invoiceLineItems.push(item);


    });

    return invoiceLineItems;
  }

  saveFees(){
    if( this.feeArray != null && this.feeArray.controls.length > 0 ){

      const invoiceLineItems = this.getFeesForSave();

      this.ordersCancellationsInternService.createUpdateAndAddInvoiceItems( this.order.id, invoiceLineItems ).subscribe( data => {
        this.showMessage('Fees saved.');
        this.refreshOrder();
      });
    }
  }





  getTableFilters() {
    return getTableFilters('cancellationOrdersTable');
  }

  /*getPrevNext(id: number) {

    console.log("prevnext");

    const filters = this.getCancellationOrdersTableFilters();
    this.ordersCancellationsInternService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }*/
  isLoadingInvoices = false;
  isLoadingAnnualFeeDeductions = false;
  annualFeeDeductions: AnnualFeeDeduction[] = [];
  invoices: Invoice[];


  getPrevNextIds(id: number) {
    const filters = this.getTableFilters();
    this.ordersCancellationsInternService.getPrevNextIds(filters, id).subscribe(result => {
      this.prevNextIds = result;
    });
  }

  gotoPrevCancellation() {

    this.router.navigate(['..', this.prevNextIds.prevId], { relativeTo: this.route }).then();

    /*const filters = this.getCancellationOrdersTableFilters();
    this.ordersCancellationsInternService.getPrev(filters, this.orderId).subscribe(result => {
      this.router.navigate(["..", result], { relativeTo: this.route });
    });*/
  }

  gotoNextCancellation() {

    this.router.navigate(['..', this.prevNextIds.nextId], { relativeTo: this.route }).then();

    /*const filters = this.getCancellationOrdersTableFilters();
    this.ordersCancellationsInternService.getNext(filters, this.orderId).subscribe(result => {
      this.router.navigate(["..", result], { relativeTo: this.route });
    });*/
  }




  initAddFeeToList(iFeeType: number, iSingleAmount: number, iNumberOfItmes: number, iName: string, invoiceLineItemId: number, iVatRate: number){

    let showYesNo = false;
    let showMultiplikator = false;
    let disableAmount = false;
    let showCustomName = true;
    let amount = (iSingleAmount == null) ? null : iSingleAmount;
    const multiplikatorValue = iNumberOfItmes;
    let name = 'Other';
    let customNameValue = (iName == '' || iName == null) ? 'Other' : iName;
    const vatRate = iVatRate;

    if(iFeeType == 1) {
      name = 'Annual fee';
      showYesNo = false;
      showMultiplikator = true;
      disableAmount = true;
      showCustomName = false;
      amount = amount == null ? (this.order.product.annualFee > 0 ? this.order.product.annualFee : this.order.product.annualFeeFromSecondYear) : iSingleAmount;

    }
    if(iFeeType == 2) {
      name = 'Issuing fee';
      showYesNo = true;
      showMultiplikator = false;
      disableAmount = true;
      showCustomName = false;
      amount = iSingleAmount == null ? this.order.product.issuingFee : iSingleAmount;

    }
    if(iFeeType == 3) {
      name = 'Inactivity fee';
      showYesNo = false;
      showMultiplikator = true;
      disableAmount = true;
      showCustomName = false;
      amount = iSingleAmount == null ? 2.50 : iSingleAmount;
      customNameValue = customNameValue;
    }

    const tmp = {
      id: invoiceLineItemId,
      feeType: iFeeType,
      name,

      showCustomName,
      customNameValue,

      showYesNo,
      yesNoValue: false,

      showMultiplikator,
      multiplikatorValue,

      disableAmount,
      amountValue: amount,
      archived: false,

      vatRate,
    };

    this.addFee(tmp);

  }

  addFeeToList(feeType: number){

    this.initAddFeeToList(feeType, null, 1, '', null, this.order.product.company.vatRate);

  }


  sendInvoice(){

    const text = 'Are you sure you want to save and send the invoice to the customer? After that you can\'t edit the invoice anymore.';
    if(this.order.cancellationInvoice != null && this.order.cancellationInvoice.isFinished){
      const text = 'Are you sure you want to send the invoice to the customer?';
    }

    this.dialog.open(ConfirmDialogComponent,{
      data:{
        title: 'Send invoice?',
        text,
        confirm: 'Ok',
        cancel: 'Cancel'
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult == 'ok') {

          if( this.feeArray != null && this.feeArray.controls.length > 0 ){

            const invoiceLineItems = this.getFeesForSave();



            this.ordersCancellationsInternService.createUpdateAndAddInvoiceItems( this.order.id, invoiceLineItems ).subscribe( data => {

              let count = 0;
              invoiceLineItems.forEach(result => {
                if( result != null && !result.archived ){
                  count = count + 1;
                }
              });

              if( count === 0) {
                this.showInfo('invoice has no items');
                return;
              }

              this.ordersCancellationsInternService.sendInvoice( this.order.id ).subscribe( data => {
                this.showMessage('invoice saved and sent.');
                this.refreshOrder();
              });
            });
          }else{
            this.showInfo('no items created');
          }



        }
      });



  }

  consoleL(){
    console.log(this.addedFeeForm);

  }


}
